<template>
  <div>
    <el-row>
      <el-col :span="24" style="display: flex; justify-content: center">
        <el-button
          style="padding: 12px; display: inline-block; margin: 0 11px"
          @click="toNavi(-1)"
          type="primary"
          >《《</el-button
        >
        <el-date-picker
          v-model="dateVals"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>

        <el-button
          style="padding: 12px; display: inline-block; margin: 0 11px"
          @click="toNavi(1)"
          type="primary"
          >》》</el-button
        >
      </el-col>
    </el-row>
    <div>
      <el-divider></el-divider> <el-tag size="small">新增咨询数据量</el-tag>
      <el-row>
        <el-col :span="24">
          <div id="xzzxl" style="width: 75%; height: 280px"></div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-divider></el-divider> <el-tag size="small">数据岗位对比</el-tag>
      <el-row>
        <el-col :span="24">
          <div id="xzzx5" style="width: 75%; height: 280px"></div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-divider></el-divider> <el-tag size="small">电邀跟进人次</el-tag>
      <el-row>
        <el-col :span="24">
          <div id="xzzx2" style="width: 75%; height: 280px"></div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-divider></el-divider>
      <el-tag size="small">约上门vs实际上门 </el-tag>
      <el-row>
        <el-col :span="24">
          <div id="xzzx3" style="width: 75%; height: 280px"></div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-divider></el-divider>
      <el-tag size="small">咨询跟进人次</el-tag>
      <el-row>
        <el-col :span="24">
          <div id="xzzx4" style="width: 75%; height: 280px"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
 
import * as echarts from 'echarts';
import api from "@/api/consu/consultation/consultation.js";

export default {
  data() {
    return {
      echart1: null,
      echart2: null,
      echart3: null,
      echart4: null,
      datas: [],
      dateVals: [],
    };
  },
  mounted() {
    let end = new Date();
    let bgn = end.getTime() - 1000 * 60 * 60 * 24 * 31;
    this.dateVals = [new Date(bgn), end];

    this.loaddata();
  },
  methods: {
    toNavi(val) {
      let bgn = 0;
      let end = 0;
      //减多少天
      let d = new Date(this.dateVals[0].getTime());
      // 将日期设置为下月一号
      d.setMonth(d.getMonth() + 1);
      d.setDate("1");
      // 获取本月最后一天
      d.setDate(d.getDate() - 1);
      let days = d.getDate();
      // console.log(days);

      if (val > 0) {
        bgn = this.dateVals[0].getTime() + 1000 * 60 * 60 * 24 * days;
        end = this.dateVals[1].getTime() + 1000 * 60 * 60 * 24 * days;
      } else {
        bgn = this.dateVals[0].getTime() - 1000 * 60 * 60 * 24 * days;
        end = this.dateVals[1].getTime() - 1000 * 60 * 60 * 24 * days;
      }

      this.$set(this, "dateVals", [new Date(bgn), new Date(end)]);

      this.loaddata();
    },
    loaddata() {
      api.mthConsu(
        {
          bgn: this.dateVals[0].format("yyyy-MM-dd"),
          end: this.dateVals[1].format("yyyy-MM-dd"),
        },
        (res) => {
          this.datas = res.data;

          this.draw月电邀与上门量();
          this.draw月简历量();
          this.draw电邀上门率();
          this.draw电邀情况分析();
          this.draw咨询情况分析();
        },
        (err) => {}
      );
    },
    draw月电邀与上门量() {
      this.echart1 = echarts.init(document.getElementById("xzzxl"));
      this.echart1.clear();
      if (this.datas.mdy1) {
        let dataValues = this.datas.mdy1;

        let seriesVal = [];
        for (var key in dataValues.datas) {
          seriesVal.push({
            name: key,
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: dataValues.datas[key],
          });
        }

        this.echart1.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            data: dataValues.nms,
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: false,
              data: dataValues.days,
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: seriesVal,
        });
      }
    },
    draw月简历量() {
      this.echart5 = echarts.init(document.getElementById("xzzx5"));
      this.echart5.clear();

      if (this.datas.mdy5) {
        let dataValues = this.datas.mdy5;

          let seriesVal = [];
        for (var key in dataValues.datas) {
          seriesVal.push({
            name: key,
            type: "line",
            data: dataValues.datas[key],
          });
        }

        this.echart5.setOption({
          title: {
            text: "",
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
              data: dataValues.nms,
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: dataValues.days,
          },
          yAxis: {
            type: "value",
          },
           series: seriesVal
        });
      }
    },
    draw电邀上门率() {
      this.echart2 = echarts.init(document.getElementById("xzzx2"));
      this.echart2.clear();
      if (this.datas.mdy2) {
        let dataValues = this.datas.mdy2;

        let seriesVal = [];
        for (var key in dataValues.datas) {
          seriesVal.push({
            name: key,
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: dataValues.datas[key],
          });
        }

        this.echart2.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            data: dataValues.nms,
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: false,
              data: dataValues.days,
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: seriesVal,
        });
      }
    },
    draw电邀情况分析() {
      this.echart3 = echarts.init(document.getElementById("xzzx3"));
      this.echart3.clear();
      if (this.datas.mdy3) {
        let dataValues = this.datas.mdy3;

        const posList = [
          "left",
          "right",
          "top",
          "bottom",
          "inside",
          "insideTop",
          "insideLeft",
          "insideRight",
          "insideBottom",
          "insideTopLeft",
          "insideTopRight",
          "insideBottomLeft",
          "insideBottomRight",
        ];
        app.configParameters = {
          rotate: {
            min: -90,
            max: 90,
          },
          align: {
            options: {
              left: "left",
              center: "center",
              right: "right",
            },
          },
          verticalAlign: {
            options: {
              top: "top",
              middle: "middle",
              bottom: "bottom",
            },
          },
          position: {
            options: posList.reduce(function (map, pos) {
              map[pos] = pos;
              return map;
            }, {}),
          },
          distance: {
            min: 0,
            max: 100,
          },
        };
        app.config = {
          rotate: 90,
          align: "left",
          verticalAlign: "middle",
          position: "insideBottom",
          distance: 15,
          onChange: function () {
            const labelOption = {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance,
            };
            myChart.setOption({
              series: [
                {
                  label: labelOption,
                },
                {
                  label: labelOption,
                },
                {
                  label: labelOption,
                },
                {
                  label: labelOption,
                },
              ],
            });
          },
        };
        const labelOption = {
          show: true,
          position: app.config.position,
          distance: app.config.distance,
          align: app.config.align,
          verticalAlign: app.config.verticalAlign,
          rotate: app.config.rotate,
          formatter: "{c}  {name|{a}}",
          fontSize: 12,
          rich: {
            name: {},
          },
        };

        this.echart3.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          legend: {
            data: ["邀约", "上门"],
          },
          toolbox: {
            show: true,
            orient: "vertical",
            left: "right",
            top: "center",
            feature: {
              mark: { show: true },
              dataView: { show: true, readOnly: false },
              magicType: { show: true, type: ["line", "bar", "stack"] },
              restore: { show: true },
              saveAsImage: { show: true },
            },
          },
          xAxis: [
            {
              type: "category",
              axisTick: { show: false },
              data: dataValues.days,
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: [
            {
              name: "邀约",
              type: "bar",
              barGap: 0,
              emphasis: {
                focus: "series",
              },
              data: dataValues.alls,
            },
            {
              name: "上门",
              type: "bar",
              emphasis: {
                focus: "series",
              },
              data: dataValues.comed,
            },
          ],
        });
      }
    },
    draw咨询情况分析() {
      this.echart4 = echarts.init(document.getElementById("xzzx4"));
      this.echart4.clear();
      if (this.datas.mdy4) {
        let dataValues = this.datas.mdy4;
        let seriesVal = [];
        for (var key in dataValues.datas) {
          seriesVal.push({
            name: key,
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: dataValues.datas[key],
          });
        }

        this.echart4.setOption({
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            data: dataValues.nms,
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: false,
              data: dataValues.days,
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: seriesVal,
        });
      }
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
</style>